import { render, staticRenderFns } from "./ProfileDba.vue?vue&type=template&id=37cdc214&"
import script from "./ProfileDba.vue?vue&type=script&lang=js&"
export * from "./ProfileDba.vue?vue&type=script&lang=js&"
import style0 from "./ProfileDba.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports